import { Entity, Field } from "typegraph";
import Tag from "common/form/entities/Tag";
import KnowledgeBase from "./KnowledgeBase";

class Category {
	@Field()
	public id: string;

	@Field()
	public name: string;
}

@Entity({ one: "article_one", many: "article_many" })
export default class Article {
	@Field()
	public id: string;

	@Field()
	public title: string;

	@Field()
	public displayName: string;

	@Field()
	public iconUrl: string;

	@Field()
	public description: string;

	//@Field()
	public owner: string;

	@Field({ entity: Category })
	public categories: Category;

	@Field({ entity: Tag })
	public tags: Tag[];
}



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/entities/Article.ts